import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetPermissionDetailsAction, adminAction} from '../action';

const tableId = 'permissions';

function* execute(action: GetPermissionDetailsAction): SagaIterator {
    const {tableDataRequest} = action.payload;
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findPermissions,
        successAction: adminAction.getPermissionDetailsSuccess,
        tableId,
    }));
}
/** Runs the admin saga that loads the selected permission details. */
export function* getPermissionDetails(): SagaIterator {
    yield takeLatestF('admin/GET_PERMISSION_DETAILS', execute);
}
